<template>
  <li v-show="currentVisibled">
    <span :class="listItemGroupClasses">{{ label }}</span>
    <ul>
      <slot></slot>
    </ul>
  </li>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import {
  BUS_LIST_ITEM__VISIBLE,
  BUS_LIST_ITEM__INVISIBLE
} from './constants'
import bus from '../../utils/bus'
const PREFIX_LIST_CLASS = `${PREFIX_CLASS}list__group`

export default {
  name: 'TListGroup',
  provide() {
    return {
      'ownerGroup': this
    }
  },
  props: {
    visibled: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      currentVisibled: true,
      currentLabel: '',
      visibledItemCount: 0
    }
  },
  computed: {
    listItemGroupClasses() {
      return `${PREFIX_LIST_CLASS}-title`
    }
  },
  created() {
    this.currentVisibled = this.visibled
    this.currentLabel = this.label
    bus.$on(BUS_LIST_ITEM__VISIBLE, this.$_onBusListItemVisible)
    bus.$on(BUS_LIST_ITEM__INVISIBLE, this.$_onBusListItemInvisible)
  },
  methods: {
    $_onBusListItemVisible(ownerGroup) {
      if (ownerGroup === this) {
        this.visibledItemCount++
        if (this.currentVisibled === false) {
          this.currentVisibled = true
        }
      }
    },
    $_onBusListItemInvisible(ownerGroup) {
      if (ownerGroup === this) {
        this.visibledItemCount--
        if (this.visibledItemCount === 0 && this.currentVisibled === true) {
          this.currentVisibled = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/list/list-group.vue